var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInboxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3C0 1.34297 1.34297 0 3 0H21C22.6547 0 24 1.34297 24 3V15C24 16.6547 22.6547 18 21 18H3C1.34297 18 0 16.6547 0 15V3ZM2.25 3V4.03594L10.3359 10.6734C11.3016 11.4703 12.6984 11.4703 13.6641 10.6734L21.75 4.03594V2.95781C21.75 2.5875 21.4125 2.20781 21 2.20781H3C2.58562 2.20781 2.25 2.5875 2.25 2.95781V3ZM2.25 6.94687V15C2.25 15.4125 2.58562 15.75 3 15.75H21C21.4125 15.75 21.75 15.4125 21.75 15V6.94687L15.0938 12.4125C13.2937 13.8891 10.7063 13.8891 8.86406 12.4125L2.25 6.94687Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxIcon);
export default __webpack_public_path__ + "static/media/inbox-icon.5cbf3835f4904972cd9f8429fb3ce40a.svg";
export { ForwardRef as ReactComponent };